import LoadingSpinner from '@/components/animations/LoadingSpinner/LoadingSpinner';
import { _t } from '@/locale';
import WeekHeader from './components/WeekHeader/WeekHeader';
import { PickTimeLoadingProps } from './PickTimeLoading.types';

/**
 * Pick-time loading content view (MPA-2580, spec FR-009).
 *
 * Spec: marketplace-specs/specs/002-MPA-2598-weekpicker (reviewed 0e23647)
 * Figma: Iteration 10 — node 502-19770 (isNarrow=False 502-19700, isNarrow=True 502-19769)
 *
 * Non-blocking loading state shown while availability is fetched. The shared
 * WeekHeader keeps the loaded picker's dimensions (nav arrows present but
 * disabled) so the hand-off to the loaded view (MPA-2581) shifts layout no more
 * than 4 px. Pair with useMinimumDisplayTime so a fast fetch doesn't flash it.
 */
const PickTimeLoading = ({ title, isNarrow = false }: PickTimeLoadingProps) => {
  const body = (
    <div className="gap-lg flex h-full w-full flex-col items-center justify-center" role="status" aria-live="polite">
      <LoadingSpinner loop style={{ width: 24, height: 24 }} />
      <p className="text-m text-fg_primary text-center">{_t('features.weekpicker.PickTimeLoading.loadingLabel')}</p>
    </div>
  );

  const header = (
    <WeekHeader
      title={title}
      subtitle={_t('features.weekpicker.subtitle')}
      isNarrow={isNarrow}
      prevDisabled
      nextDisabled
    />
  );

  if (isNarrow) {
    return (
      <div className="border-border_regular flex h-full w-full flex-col border-b">
        {header}
        <div className="border-border_regular bg-surface_l2 flex-1 border-t">{body}</div>
      </div>
    );
  }

  return (
    <div className="border-border_regular bg-surface_l2 flex h-full w-full flex-col overflow-hidden rounded-lg border">
      {header}
      <div className="flex-1">{body}</div>
    </div>
  );
};

export default PickTimeLoading;
